/**
 * This file provides common resources for all upp components.
 */

/**
 * Country codes are used in Country select boxes for pos and market screens. In future we may retrieve
 * from database or any other resource input. For the time being we will keep them hardcoded.
 */
export const countryCodes = (): string[] => [
  'AD',
  'AE',
  'AF',
  'AG',
  'AI',
  'AL',
  'AM',
  'AO',
  'AQ',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'AX',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BL',
  'BM',
  'BN',
  'BO',
  'BQ',
  'BQ',
  'BR',
  'BS',
  'BT',
  'BV',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CC',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CK',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CU',
  'CV',
  'CW',
  'CX',
  'CY',
  'CZ',
  'DE',
  'DJ',
  'DK',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'EH',
  'ER',
  'ES',
  'ET',
  'FI',
  'FJ',
  'FK',
  'FM',
  'FO',
  'FR',
  'GA',
  'GB',
  'GD',
  'GE',
  'GF',
  'GG',
  'GH',
  'GI',
  'GL',
  'GM',
  'GN',
  'GP',
  'GQ',
  'GR',
  'GS',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'HM',
  'HN',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IM',
  'IN',
  'IO',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JE',
  'JM',
  'JO',
  'JP',
  'KE',
  'KG',
  'KH',
  'KI',
  'KM',
  'KN',
  'KP',
  'KR',
  'KW',
  'KY',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MF',
  'MG',
  'MH',
  'MK',
  'ML',
  'MM',
  'MN',
  'MO',
  'MP',
  'MQ',
  'MR',
  'MS',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NC',
  'NE',
  'NF',
  'NG',
  'NI',
  'NL',
  'NO',
  'NP',
  'NR',
  'NU',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PF',
  'PG',
  'PH',
  'PK',
  'PL',
  'PM',
  'PN',
  'PR',
  'PS',
  'PT',
  'PW',
  'PY',
  'QA',
  'RE',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SB',
  'SC',
  'SD',
  'SE',
  'SG',
  'SH',
  'SI',
  'SJ',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'SS',
  'ST',
  'SV',
  'SX',
  'SY',
  'SZ',
  'TC',
  'TD',
  'TF',
  'TG',
  'TH',
  'TJ',
  'TK',
  'TL',
  'TM',
  'TN',
  'TO',
  'TR',
  'TT',
  'TV',
  'TW',
  'IS',
  'TZ',
  'UA',
  'UG',
  'UM',
  'US',
  'UY',
  'UZ',
  'VA',
  'VC',
  'VE',
  'VG',
  'VI',
  'VN',
  'VU',
  'WF',
  'WS',
  'YE',
  'YT',
  'ZA',
  'ZM',
  'ZW'
];

export enum FeatureFlags {
  hotelsV2 = 'UPP_HOTELS_V2_А',
  ruleActiveRange = 'UPP_RULE_ACTIVE_RANGE_A',
  ruleHistory = 'UPP_RULE_HISTORY_A',
  carrierTransportModes = 'UPP_TRANSPORT_CARRIER_GROUPS_A',
  flightsFareType = 'UPP_FLIGHTS_FARETYPE_A',
  agGridTables = 'UPP_AG_GRID_TABLES_A',
  flightsNdcParity = 'UPP_FLIGHTS_NDC_PARITY_A',
  flightsProductField = 'UPP_FLIGHTS_PRCODECORR_A',
  troubleshootingPanel = 'UPP_TROUBLESHOOTING_A',
  productInstantSearch = 'UPP_PRODUCT_MPIS_A',
  pagination = 'UPP_PAGINATION_A',
  partialNameMatch = 'UPP_PARTIAL_NAME_MATCH_A',
  showDFSideNav = 'UPP_DFSIDENAV_A',
  flightsUiChanges = 'UPP_UI_CHANGES_FLIGHTS_A',
  flightsAirlineCriteria = 'UPP_AIRLINE_CRITERIA_FLIGHTS_A',
  excludeIntracityConnections = 'UPP_EXCLUDE_INTRCITY_A',
  spacesAllowedInPosAndMarkets = 'UPP_POS_MARKETS_NAME_A'
}
